import './icon-tile.scss';

import type { StaticImageData } from 'next/image';
import React from 'react';

import { Image } from '@sola/ark-core/atoms/image/image.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';

export type IconTileSize = 'sm' | 'lg';

const sizeMap = {
  sm: 76,
  lg: 100,
};

export interface IconTileProps {
  imgSrc: string | StaticImageData;
  alt: string;
  size?: IconTileSize;
}

export const IconTile: React.FC<IconTileProps> = ({
  imgSrc,
  alt,
  size = 'lg',
}) => {
  const dimension = sizeMap[size];

  return (
    <div
      className={cn('IconTile', {
        'IconTile--sm': size === 'sm',
      })}
    >
      <Image
        src={imgSrc}
        alt={alt}
        width={dimension}
        height={dimension}
        className="IconTile__image"
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
};
